<div #ggcMousePosition class="ggc-mouse-position"></div>
